import React, { useState, useContext } from "react";
import {
  NavbarBrand,
  Badge,
  NavbarToggler,
  NavLink,
  Collapse,
  UncontrolledTooltip,
} from "reactstrap";
import { Icon, Nav, Navbar, NavItemContainer } from "./style";
import logo from "../assets/img/boxs_logo_new.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getCurrentUser, setUserAsGuest } from "../auth/service";
import { isBrowser, isMobileOnly } from "react-device-detect";
import { Option } from "../product/style";
import { AppContext } from "../context";
import { isInternalAccess } from "../common/service";
import SampleVideos from "./SampleVideos";
import UserManagementModal from "../users/UserManagementModal";

function Header(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [sampleVideosOpen, setsampleVideosOpen] = useState(false);
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const params = useParams();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const appContext = useContext(AppContext);
  const openCart = appContext?.openCart;
  const handleViewCart = (e) => {
    if (e) e.preventDefault();
    if (e) e.stopPropagation();
    if (typeof openCart === "function") openCart();
    else navigate("/store");
  };
  const toggleSampleVideosModal = () => setsampleVideosOpen(!sampleVideosOpen);
  const [isManageUserModalOpen, setIsManagerUserModalOpen] = useState(false);

  const logoutUser = () => {
    setUserAsGuest();
    navigate("/login_with_otp");
  };

  if (
    (isMobileOnly &&
      params.productId &&
      !location.pathname.startsWith("/cl")) ||
    location.pathname.endsWith("promo")
  ) {
    return null;
  }

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      {currentUser && currentUser.hasOwnProperty("proxy") && (
        <div className="bg-danger text-white p-3 text-center w-100 fw-bold fs-6 position-sticky top-0 z-1">
          PROXY USER
        </div>
      )}

      <Navbar
        className="px-sm-4 px-3"
        top={
          currentUser && currentUser.hasOwnProperty("proxy") ? "56px" : "0px"
        }
        expand="sm"
      >
        <NavbarBrand className="pb-2" href="/">
          <img src={logo} alt="logo" className="img-fluid logo" />
        </NavbarBrand>
        {isInternalAccess() && (
          <span className="fs-14px text-secondary border px-2 rounded-2">
            internal
          </span>
        )}
        {props.nav && (
          <>
            <div className="me-auto"></div>

            <div className="d-flex pt-3 pb-2 p-sm-0 align-items-center gap-2">
              {!currentUser || currentUser.isFromLandingPage ? (
                <>
                  <NavLink
                    tag="div"
                    className="fw-bold pointer p-1 text-primary d-flex align-items-center"
                    onClick={handleViewCart}
                    title="View Cart"
                  >
                    <Icon className="fa-solid fa-shopping-cart me-1" size="16px" />
                    View Cart
                  </NavLink>
                  <NavItem
                    children="Login"
                    icon="fa-solid fa-user"
                    onClick={() => navigate("/login_with_otp")}
                  />
                </>
              ) : (
                <div className="d-flex align-items-center">
                  {isBrowser ? (
                    <div className="d-flex pt-3 pb-2 p-sm-0 gap-3">
                      <NavLink
                        tag="div"
                        className="fw-bold pointer p-1 text-primary d-flex align-items-center"
                        onClick={handleViewCart}
                        title="View Cart"
                      >
                        <Icon className="fa-solid fa-shopping-cart me-1" size="16px" />
                        View Cart
                      </NavLink>
                      <NavLink
                        className="fw-bold pointer p-1 text-primary"
                        onClick={props.toggleSampleModal}
                      >
                        Sample Orders
                      </NavLink>
                      <NavLink
                        className="fw-bold pointer p-1 text-primary"
                        onClick={toggleSampleVideosModal}
                      >
                        How to use Boxs?
                      </NavLink>
                      {currentUser.access?.manage_users && (
                        <NavLink
                          className="fw-bold pointer p-1 text-primary"
                          onClick={() => setIsManagerUserModalOpen(true)}
                        >
                          Manage Users
                        </NavLink>
                      )}
                      <UserManagementModal
                        isOpen={isManageUserModalOpen}
                        toggle={() =>
                          setIsManagerUserModalOpen(!isManageUserModalOpen)
                        }
                      />
                      <div className="d-flex align-items-center">
                        <div className="d-flex flex-column">
                          <span className="text-secondary" id="user_name">
                            {currentUser.name}
                          </span>
                          <UncontrolledTooltip
                            target="user_name"
                            placement="bottom"
                          >
                            {currentUser.org_name}
                          </UncontrolledTooltip>
                        </div>
                        <Icon
                          className="fa-solid fa-power-off ms-2 pointer"
                          onClick={logoutUser}
                          title="Log Out"
                        />
                      </div>
                    </div>
                  ) : (
                    <NavbarToggler onClick={toggleNavbar} className="" />
                  )}
                </div>
              )}
            </div>
            {isMobileOnly && (
              <Collapse isOpen={collapsed} navbar>
                {!currentUser || currentUser.isFromLandingPage ? (
                  <Nav navbar className="gap-0">
                    <NavItem>
                      <NavLink
                        tag="div"
                        onClick={handleViewCart}
                        className="fw-bold"
                      >
                        View Cart
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={() => navigate("/modules")}
                        className="fw-bold"
                      >
                        Modules
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={() => navigate("/projects")}
                        className="fw-bold"
                      >
                        Projects
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink onClick={logoutUser} className="fw-bold">
                        Log Out
                      </NavLink>
                    </NavItem>
                  </Nav>
                ) : (
                  <div className="d-lg-none position-absolute top-100 start-0 w-100">
                    <Nav className="bg-white box-shadow border rounded-bottom gap-2 mx-4 px-2 d-flex flex-column align-items-end gap-2 nav py-2">
                      <NavItem
                        className="fw-bold pointer p-1"
                        onClick={handleViewCart}
                      >
                        <div className="fw-bold">View Cart</div>
                      </NavItem>
                      <NavItem
                        className="fw-bold pointer p-1"
                        onClick={props.toggleSampleModal}
                      >
                        <div className="fw-bold">Sample Orders</div>
                      </NavItem>
                      <NavItem
                        className="fw-bold pointer p-1"
                        onClick={toggleSampleVideosModal}
                      >
                        <div className="fw-bold">How to use Boxs?</div>
                      </NavItem>
                      <NavItem
                        className="fw-bold pointer p-1"
                        onClick={logoutUser}
                      >
                        <div className="fw-bold">Log out</div>
                      </NavItem>
                    </Nav>
                  </div>
                )}
              </Collapse>
            )}
          </>
        )}
      </Navbar>
      <SampleVideos
        isOpen={sampleVideosOpen}
        toggle={toggleSampleVideosModal}
      />
    </>
  );
}

function NavItem(props) {
  return (
    <NavItemContainer
      className="d-flex align-items-center pointer"
      onClick={props.onClick}
    >
      <Icon className={props.icon} size="20px" />
      <div className="m-0">{props.children}</div>
    </NavItemContainer>
  );
}

export default Header;
